export default "assets/images/v_bg-56928b13.png";